var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M16.163 21.621h9.962"
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M10.058 15.114V4.45h7.471l3.214 3.177h12.131v7.567"
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M5.559 15.574h31.814v22.269H5.559z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 14.768,
    cy: 8.881,
    r: 1.399
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.59d940f877652cf5202cf953baa303e6.svg";
export { ForwardRef as ReactComponent };